import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import RegisterForm from "../register/Register";
import { getAssetUrl } from "../../utils/assetUrl";
import "./Login.css";

type AuthView = "login" | "register";

const IconEye = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const IconEyeSlash = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const swalPopupClass = {
  popup: "custom-swal",
  title: "custom-title",
  htmlContainer: "custom-text",
};

const Login: React.FC = () => {
  const Cookies = require("js-cookie");

  const [view, setView] = useState<AuthView>("login");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const bgUrl = `${process.env.PUBLIC_URL || ""}/assets/bg-pc.png`;

  useEffect(() => {
    document.documentElement.classList.add("login-scroll-lock");
    document.body.classList.add("login-scroll-lock");

    return () => {
      document.documentElement.classList.remove("login-scroll-lock");
      document.body.classList.remove("login-scroll-lock");
    };
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: swalPopupClass,
      });
      return;
    }

    setSubmitting(true);
    try {
      Swal.fire({
        title: "Đang xử lý...",
        html: "<p class='swal-loading-subtext'>Vui lòng chờ trong giây lát</p><div class='swal-loading-dots'><span class='swal-dot swal-dot-cyan'></span><span class='swal-dot swal-dot-orange'></span></div>",
        customClass: {
          popup: "custom-swal swal-loading-modal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      await new Promise((resolve) => setTimeout(resolve, 1000));

      const { data, status } = await axios.post(
        `${process.env.REACT_APP_URL_API}/auth/login`,
        {
          username: userName,
          password,
        }
      );

      localStorage.setItem(
        "user_info",
        JSON.stringify({
          userName: data.user.username,
          coins: data.user.coins,
          role: data.user.role,
          id: data.user._id,
        })
      );

      Cookies.set("access_token", data.access_token, {
        expires: 1 / 24,
        secure: false,
        sameSite: "Lax",
      });

      await new Promise((resolve) => setTimeout(resolve, 100));

      const isAdmin =
        status === 201 &&
        (data.user.role === "SUPERADMIN" || data.user.role === "ADMIN");

      Swal.fire({
        icon: "success",
        title: "Đăng nhập thành công",
        text: isAdmin ? undefined : "Vui lòng đợi ít phút.",
        timer: 1200,
        showConfirmButton: false,
        customClass: swalPopupClass,
      });

      setTimeout(() => {
        window.location.href = isAdmin ? "/admin" : "/";
      }, 500);
    } catch (err: any) {
      if (err?.response?.status === 401) {
        Swal.fire({
          icon: "error",
          title: "Lỗi đăng nhập",
          text: "Tài khoản/mật khẩu không chính xác!",
          customClass: swalPopupClass,
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div
        className="login-page__bg"
        style={{ backgroundImage: `url(${bgUrl})` }}
        aria-hidden
      />

      <div className="auth-modal-wrapper" style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", alignItems: "center", width: "100%", maxWidth: 660 }}>
        <img
          src={getAssetUrl("/assets/wintool79-title.png")}
          alt="WINTOOL79.COM"
          className="auth-modal__banner-title"
          style={{
            width: "min(640px, 96vw)",
            height: "auto",
            objectFit: "contain",
            marginBottom: 52,
            zIndex: 10,
            filter: "drop-shadow(0 0 32px rgba(0, 229, 255, 0.95))",
          }}
        />

        <div className="auth-modal">
          <div className="auth-modal__avatar-wrap">
            <img
              src={getAssetUrl("/assets/robot-login.png")}
              alt="Robot Panda Avatar"
              className="auth-modal__avatar"
            />
          </div>

        {view === "login" ? (
          <>
            <h1 className="auth-modal__title">&gt;_ĐĂNG  NHẬP_&lt;</h1>
            <form className="auth-modal__form" onSubmit={handleLogin} noValidate>
              <div className="auth-modal__input-wrapper">
                <input
                  className="auth-modal__input auth-modal__input--no-icon"
                  type="text"
                  id="txtUsername"
                  placeholder="Nhập tên tài khoản"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  maxLength={16}
                  minLength={4}
                  autoComplete="username"
                  required
                />
              </div>

              <div className="auth-modal__input-wrapper">
                <input
                  className="auth-modal__input"
                  type={showPassword ? "text" : "password"}
                  id="txtPassword"
                  placeholder="Nhập mật khẩu"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  maxLength={16}
                  minLength={4}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="auth-modal__toggle-pwd"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                  aria-label="Hiện/Ẩn mật khẩu"
                >
                  {showPassword ? <IconEyeSlash /> : <IconEye />}
                </button>
              </div>

              <button
                type="submit"
                className="auth-modal__submit"
                disabled={submitting}
              >
                ĐĂNG NHẬP NGAY
              </button>
            </form>

            <p className="auth-modal__footer">
              Chưa có tài khoản?{" "}
              <button
                type="button"
                className="auth-modal__link"
                onClick={() => setView("register")}
              >
                Đăng ký ngay
              </button>
            </p>
          </>
        ) : (
          <RegisterForm onSwitchToLogin={() => setView("login")} />
        )}
      </div>
    </div>
  </div>
);
};

export default Login;
